import React from 'react'
import injectStyles from 'react-jss'
import LoginContinue from './LoginContinue'

const styles = {
  page: {
    textAlign: 'center',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  boxOuter: {
    width: '100%',
  },

}

const PageWithBox = ({ classes, queryString, children }) => <div className={classes.page}>
  <div className={classes.boxOuter}>
    <Box>
      <LoginContinue queryString={queryString} />
    </Box>
  </div>
</div>

export default injectStyles(styles)(PageWithBox)

const Box = injectStyles({
  box: {
    width: 747,
    backgroundColor: 'white',
    padding: '86px 168px',
    boxSizing: 'border-box',
    margin: '0 auto',
    border: '1px solid #ebedf0',
    borderRadius: 5,
  },
})(({ classes, children }) => <div className={classes.box}>
  {children}
</div>)




// WEBPACK FOOTER //
// ./src/pages/Login/Login.js